import axios from 'axios'
import config from './config'

const URL = `${config.URL}/persons`

export async function create (data) {
  let form = new FormData()
  Object.keys(data).forEach(function (key) {
    if (data[key]) {
      if (data[key] === 'image') {
        form.append([key], data[key], data[key].name)
      } else {
        if (key === 'profession') {
          for (let index = 0; index < data[key].length; index++) {
            const id = data[key][index]
            form.append('profession[]', id)
          }
        } else {
          form.append([key], data[key])
        }
      }
    }
  })
  const result = await axios.post(`${URL}`, form, config.configWithToken())
  return result.data
}

export async function detail (id) {
  const result = await axios.get(`${URL}/detail/${id}`, config.configWithToken())
  return result.data
}

export async function list (page) {
  const result = await axios.get(`${URL}/listAll/${page}`, config.configWithToken())
  return result.data
}

export async function change (id, status) {
  const result = await axios.post(`${URL}/change/status`, {
    status: status,
    id: id
  }, config.configWithToken())
  return result.data
}

export async function update (id, data) {
  let form = new FormData()
  Object.keys(data).forEach(function (key) {
    if (data[key]) {
      if (data[key] === 'image') {
        form.append([key], data[key], data[key].name)
      } else {
        if (key === 'profession') {
          for (let index = 0; index < data[key].length; index++) {
            const id = data[key][index]
            form.append('profession[]', id)
          }
        } else {
          form.append([key], data[key])
        }
      }
    }
  })
  const result = await axios.post(`${URL}/update/${id}`, form, config.configWithToken())
  return result.data
}

export async function search (page, name) {
  const response = await axios.get(`${URL}/search/${page}/${name}`, config.configWithToken())
  return response.data
}

export async function deletes (id) {
  const result = await axios.get(`${URL}/remove/${id}`, config.configWithToken())
  return result.data
}

export async function listProfession (page, id) {
  const result = await axios.get(`${URL}/listProfession/${id}/${page}`, config.configWithToken())
  return result.data
}

export default {
  list,
  detail,
  change,
  create,
  update,
  search,
  deletes,
  listProfession
}
